module.exports = __webpack_public_path__ + "static/media/level1_q2_correct.69a44ffe.png";